export default "__VITE_ASSET__bj21BspQ__"